import React from 'react'
import { Tooltip } from '@mui/material'
import { currencyText } from '../../../../../../helpers/unitMeasure/UnitMeasureHelper'

const SupplyBillPriceOne = ({ value, type, title, currency }) => {
    
  return (
    <>
        {
            value ?
                <p className={`agreePrice__${type} fs16`}>
                    <Tooltip title={title}>
                        {value.toLocaleString('ru')} {currencyText[currency]}
                    </Tooltip>
                </p>
            : ''
        }
    </>
  )
}

export default SupplyBillPriceOne